import Services from './index';
import { GUIDE_BY_ROLE_URL, GUIDE_URL } from 'consts/api';

class GuidelineServices {
  getGuide() {
    return Services.get(GUIDE_URL);
  }

  getGuideByRole({ role }) {
    return Services.get(`${GUIDE_BY_ROLE_URL}?role=${role}`);
  }

  saveGuideline(role, body) {
    return Services.post(`${GUIDE_BY_ROLE_URL}?role=${role}`, body);
  }

  deleteGuideline(body) {
    return Services.delete(GUIDE_BY_ROLE_URL, { data: { ids: body } });
  }
}

export default new GuidelineServices();
